import { Tool } from "./interfaces";

export const applications = [
  {
    type: "application",
    name: "Adobe XD",
    level: "Experienced",
    image: "adobe-xd.svg",
    tags: ["Adobe", "UI/UX", "SVG", "illustrations"],
    experience: "+3 years",
    description: "",
  },
  // {
  //   type: "application",
  //   name: "Adobe Illustrator",
  //   level: "Intermediate",
  //   image: "adobe-illustrator.svg",
  //   tags: ["Adobe", "illustrations", "SVG"],
  //   experience: "+5 years",
  //   description: "",
  // },
  {
    type: "application",
    name: "Google Data Studio",
    level: "Experienced",
    image: "google-data-studio.svg",
    tags: ["Google", "Data", "Reporting", "Dashboards"],
    experience: "+2 years",
    description: "",
  },
  {
    type: "application",
    name: "Tableau",
    level: "Intermediate",
    image: "tableau.svg",
    tags: ["Analytics", "Data", "Reporting", "Dashboards"],
    experience: "1 year",
    description: "",
  },
  {
    type: "application",
    name: "Google Sheet",
    level: "Intermediate",
    image: "google-sheet.svg",
    tags: ["Analytics", "Data"],
    experience: "+4 year",
    description: "",
  },
  // {
  //   type: "application",
  //   name: "Invision Studio",
  //   level: "Intermediate",
  //   image: "invision-studio.svg",
  //   tags: ["Invision", "UI/UX", "Interfaces"],
  //   experience: "1 year",
  //   description: "",
  // },
  {
    type: "application",
    name: "Hackolade",
    level: "Experienced",
    image: "hackolade.svg",
    tags: ["Database", "Modeling", "No-SQL"],
    experience: "+3 years",
    description: "",
  },
  {
    type: "application",
    name: "Studio 3T",
    level: "Intermediate",
    image: "studio-3t.svg",
    tags: ["Database", "MongoDB", "Management", "No-SQL"],
    experience: "+3 years",
    description: "",
  },
  {
    type: "application",
    name: "MongoDB Atlas",
    level: "Intermediate",
    image: "mongodb.svg",
    tags: ["Database", "MongoDB", "Management", "No-SQL"],
    experience: "+2 years",
    description: "",
  },
] as Array<Tool>;
